import React, { useEffect } from 'react'
import { Route, Routes } from 'react-router-dom'
import AboutPage  from 'modules/AboutPage/index'
import Account from 'modules/Account/index'
import Business from 'modules/Business/index'
import BusinessAccount from 'modules/BusinessAccount'
import Admin from 'modules/Admin'
import { ReadOnlyProvider } from 'modules/Admin/ReadOnlyNotice'
import FAQ from 'modules/FAQ/index'
import LandingPage from 'modules/LandingPage/index'
import LoginPage from 'modules/LoginPage/index'
import SignupPage from 'modules/SignupPage/index'
import PrivacyPage from 'modules/PrivacyPage/index'
import ResetPassword from 'modules/ResetPassword/index'
import SearchPageContainer from 'modules/SearchPageContainer/index'
import SetPassword from 'modules/SetPassword/index'
import TermsPage from 'modules/TermsPage/index'
import FeedbackPage from 'modules/FeedbackPage/index'
import { useDispatch } from 'react-redux'
import { fetchUserLocation } from 'modules/User/actions'
import NotFound from 'components/NotFound'

const App = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchUserLocation())
  }, [dispatch])

  return (
    <ReadOnlyProvider>
    <Routes>
      <Route path="/*" exact element={<LandingPage/>} />
      <Route path="/search/*" exact element={<SearchPageContainer/>} />
      <Route path="/help" exact element={<FAQ/>} />
      <Route path="/privacy" exact element={<PrivacyPage/>} />
      <Route path="/terms" exact element={<TermsPage/>} />
      <Route path="/feedback" exact element={<FeedbackPage/>} />
      <Route path="/about" exact element={<AboutPage/>} />
      <Route path="/account/*" element={<Account/>} />
      <Route path="/business" element={<Business/>} />
      <Route path="/business/*" element={<NotFound/>} />
      <Route path="/business-account/:organizationId/business/*" element={<Business/>} />
      <Route path="/business-account/:organizationId" element={<BusinessAccount/>} />
      <Route path="/admin/*" element={<Admin/>} />
      <Route path="/login" element={<LoginPage/>} />
      <Route path="/signup" element={<SignupPage/>} />
      <Route path="/reset-password" element={<ResetPassword/>} />
      <Route path="/set-password" element={<SetPassword/>} />
      <Route element={<NotFound/>} />
    </Routes>
    </ReadOnlyProvider>
  )
}

export default App
